import React, { useEffect, useState } from 'react';

import { Logger } from '../../services';
import { useInvertedLocalize } from '../../utils/localization';
import { invertedMessages } from '../../utils/messages';

import './Iframe.css';

interface IframeProps {
  iframeUrl: string;
  title: string;
  LoaderComponent: React.ReactNode;
  testId: string;
}

Iframe.default = {
  testId: '',
};

export default function Iframe({
  iframeUrl,
  title,
  LoaderComponent,
  testId,
}: IframeProps) {
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const l = useInvertedLocalize(invertedMessages);

  // // TODO: We have use react-cookie for useCookies
  const getCookie = (name: string): string | null => {
    const cookies = document.cookie.split(';').map((cookie) => cookie.trim());
    const cookie = cookies.find((item) => item.startsWith(`${name}=`));

    return cookie ? decodeURIComponent(cookie.split('=')[1]) : null;
  };

  useEffect(() => {
    const token = getCookie('access_token');

    if (token && iframeUrl) {
      const iframeOrigin = new URL(iframeUrl).origin;

      const messageHandler = (event: MessageEvent) => {
        Logger.log('Message Emmiting');

        if (event.origin === iframeOrigin) {
          Logger.log(`Message Sent to ${iframeOrigin}`);
          (event.source as Window).postMessage({ token }, iframeOrigin);
        }
      };

      window.addEventListener('message', messageHandler);

      return () => {
        window.removeEventListener('message', messageHandler);
      };
    }

    return () => {};
  }, [iframeUrl]);

  return (
    <section
      className='Ispm-IframeContainer'
      aria-label={l('Iframe container')}>
      {!isLoaded && LoaderComponent}
      <iframe
        title={title}
        className='Ispm-IframeContainer-iframe'
        src={iframeUrl}
        onLoad={() => setIsLoaded(true)}
        style={{
          display: isLoaded ? 'block' : 'none',
        }}
        data-testid={`${testId}-iframe`}
      />
    </section>
  );
}
